import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const RevenueCentersList = ({ revenueCenters }) => (
  <ul className="revenue-centers-list">
    {revenueCenters.map(revenueCenter => (
      <li className="revenue-centers-list__item" key={revenueCenter.uuid}>
        <Link className="revenue-centers-list__link" to={`/orders/${revenueCenter.uuid}`}>
          {revenueCenter.name}
        </Link>
      </li>
    ))}
  </ul>
)

RevenueCentersList.propTypes = {
  revenueCenters: PropTypes.array,
}

export default RevenueCentersList
